<script>
	module.exports = {
		props: ['eventClick']
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.aad-content {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		> * {
			margin-bottom: 5rem;
		}

		.video-panel {
			flex: 2;
			min-width: 300px;
			margin-right: 2rem;

			.video-blurb {
				margin: 2rem 0;
			}

			iframe {
				width: 100%;
				height: auto;
				min-height: 14rem;
			}
		}

		.aad-action {
			flex: 3;
			display: flex;
			flex-direction: column;
			align-items: center;

			a {
				display: flex;
				align-items: center;
				justify-content: center;
				margin-bottom: 0.5rem;
				width: 18rem;
				height: 8rem;
				border: 1px solid $c-blue;
				border-radius: 4px;

				&.start-searching {
					background-color: $c-blue;
					color: $c-white;
				}
			}
		}
	}
</style>
<template>
	<section>
		<div class="aad-content">
			<div class="video-panel">
				<div class="video-blurb">
					Article-A-Day&trade; is a 10 minute daily routine that dramatically increases your students' background knowledge, vocabulary, and stamina.
				</div>
				<vimeo-player :video-id="254905483"> </vimeo-player>
			</div>
			<div class="aad-action">
				<a
					href="/find-content#!pt:AAD"
					class="start-searching"
					@click="eventClick && eventClick('search_aad')">
					Search Article-A-Day Sets
				</a>
				<a
					href="/teacher-guide/article-a-day-routine.html"
					class="learn-more"
					@click="eventClick && eventClick('learn_routine')">
					Learn the Routine
				</a>
			</div>
		</div>
		<a
			href="/find-content"
			class="take-me-to-search text-muted"
			@click="eventClick && eventClick('search')">
			Take me to search
		</a>
	</section>
</template>
